if (!customElements.get('size24-cns-preview')) {
  customElements.define('size24-cns-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.syncPreviewRoute = this.syncPreviewRoute.bind(this);
      this.syncPreviewRoute();
      for (const event of ['pointerdown', 'keydown', 'click', 'change', 'submit']) {
        this.addEventListener(event, this.syncPreviewRoute, { capture: true, signal: this.controller.signal });
      }
      this.observer = new MutationObserver(this.syncPreviewRoute);
      this.observer.observe(this, { childList: true, subtree: true });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
    previewURL(value) {
      const url = new URL(value, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return value;
      url.searchParams.set('view', this.dataset.previewView);
      return url.pathname + url.search + url.hash;
    }
    syncPreviewRoute() {
      for (const form of this.querySelectorAll('facets-form-component form')) {
        let input = form.querySelector('input[name="view"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'view';
          form.append(input);
        }
        input.value = this.dataset.previewView;
      }
      for (const element of this.querySelectorAll('[data-url], a[href]')) {
        const attribute = element.hasAttribute('data-url') ? 'data-url' : 'href';
        const value = element.getAttribute(attribute);
        if (!value) continue;
        const next = this.previewURL(value);
        if (next !== value) element.setAttribute(attribute, next);
      }
    }
  });
}
